<template>
  <div class="swiper">
    <h2>{{ title }}</h2>
    <product-modal v-on:close="closeProductModal" ></product-modal>
    <modal-addItemToCart></modal-addItemToCart>

    <swiper :options="vendorSwiperOptions" ref="vendorSwiper">
      <swiper-slide v-for="product in products.data" :key="Math.random().toString(36).substr(2, 9)">
        <div class="card product-card">
          <div class="card-overlay">
            <button class="btn overlay" @click.prevent="showProduct(product)">Zum Produkt</button>
            <button class="btn icon outline green" @click.prevent="addToCart(product)"><span><icon class="icon"
                                                                                           name="cart-plus"></icon></span><span>In den Warenkorb</span>
            </button>
            <!-- <button class="btn orange">Aus Favoriten entfernen</button> -->
          </div>
          <span class="cat-label">
            <icon name="sliders" class="icon rotate-90"></icon>
            <span>{{ product.category.name }}</span>
          </span>
          <img-comp :element="product" size="s" :alt="product.name"></img-comp>
          <div class="lg:hidden xl:hidden flex">
            <button :class="['btn orange inline-block w-1/2 rounded-none', 'w-full' ]"
                    @click.prevent="showProduct(product)">Zum Produkt
            </button>
            <button class="btn icon green inline-block w-1/2 rounded-none"
                    @click.prevent="addToCart(product)">
              <span><icon class="icon" name="cart-plus"></icon></span>
              <span>In den Warenkorb</span>
            </button>
          </div>
          <div class="text">
            <h3>{{ product.name }}</h3>
            <p>von <span class="vendor-name">{{ product.shop.name }}</span></p>
            <p><span
                class="price">{{ formatPrice(product, 'unit') }}</span><span> pro {{ getTextFromUnit(product.unit) }}</span>
            </p>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination-wrapper">
      <div class="icon outline vendor-swiper-prev">
        <icon name="chevron-left" scale="1.25"></icon>
      </div>
      <div class="vendor-swiper-pagination" slot="pagination"></div>
      <div class="icon outline vendor-swiper-next">
        <icon name="chevron-right" scale="1.25"></icon>
      </div>
    </div>
  </div>
</template>

<script>
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'
  import ProductModal from '@/components/modals/Product'
  import AddItemToCart from '@/components/modals/AddItemToCart.vue'
  import {EventBus} from '@/assets/js/event-bus.js'
  import {mapActions} from 'vuex'

  export default {
    name: 'productSlider',
    props: {
      products: {
        type: Object,
        default: function () {
          return {
            data: [],
            links: {
              next: null
            }
          }
        },
        required: true
      },
      title: {
        type: String,
        default: ''
      }
    },
    components: {
      ProductModal,
      'modal-addItemToCart': AddItemToCart
    },
    mixins: [helpers, formatting],
    data () {
      return {
        showProductModal: false,
        vendorSwiperOptions: {
          loop: true,
          slidesPerView: 3,
          spaceBetween: 20,
          pagination: {
            el: '.vendor-swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.vendor-swiper-next',
            prevEl: '.vendor-swiper-prev'
          },
          breakpoints: {
            1300: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            713: {
              slidesPerView: 'auto',
              spaceBetween: 10
            }
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'getShopProduct'
      ]),
      closeProductModal () {
        this.showProductModal = false
        EventBus.$emit('toggleProductModal')
      },
      showProduct (product) {
        var self = this
        var payload = {
          product: product.uid
        }
        this.$store.commit('PRODUCT_SET_SELECTED_PRODUCT', null)
        this.getShopProduct(payload)
        self.showProductModal = true
        EventBus.$emit('toggleProductModal')
      },
      toggleFilterModal () {
        EventBus.$emit('toggleFilterModal')
      },
      loadMore () {
      },
      addToCart (product) {
        EventBus.$emit('toggleAddItemToCartModal', product)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/slider/productSlider.vue